import { useState } from 'react';

import { LoginForm } from '@/components/login-form';
import { SignupForm } from '@/components/signup-form';

/**
 * The signed-out surface.
 *
 * Sign-in and sign-up are one screen with a mode rather than two routes: every
 * route in this SPA lives behind `AuthGate`, so a `/signup` path would have to
 * be carved out of the gate for a form that is only ever reached from the link
 * beneath the other one.
 */
export function AuthScreen() {
  const [mode, setMode] = useState<'login' | 'signup'>('login');

  return (
    <div className="bg-muted flex min-h-svh flex-col items-center justify-center p-6 md:p-10">
      <div className="w-full max-w-sm md:max-w-4xl">
        {mode === 'login' ? (
          <LoginForm onSwitchToSignup={() => setMode('signup')} />
        ) : (
          <SignupForm onSwitchToLogin={() => setMode('login')} />
        )}
      </div>
    </div>
  );
}
